import { useEffect, useState } from "react"
import { Modal, Row, Col, Stack, Alert } from "react-bootstrap"
import { useCompanySettingsStore } from "../../api/company/store"
import Loading from "../../components/Loading"
import MenuButton from "../../components/MenuButton"
import SettingsSection from "./SettingsSection"
import DiagnosticsSection from "./DiagnosticsSection"
import { 
    CATEGORY_GENERAL, 
    CATEGORY_SECURITY, 
    CATEGORY_FEATURES, 
    CATEGORY_MOBILE_BANKING,
    CATEGORY_DIAGNOSTICS,
    CATEGORY_NAMES 
} from "../../api/company/data"

interface CompanySettingsProps {
    show: boolean
    onHide: () => void
}

const CompanySettings = ({ show, onHide }: CompanySettingsProps) => {
    const { 
        loading, 
        settings, 
        error, 
        retrieveSettings, 
        clearError 
    } = useCompanySettingsStore(state => state)
    
    const [selectedCategory, setSelectedCategory] = useState(CATEGORY_SECURITY)
    
    useEffect(() => {
        if (show && !settings) {
            retrieveSettings()
        }
    }, [show, settings, retrieveSettings])
    
    const handleClose = () => {
        clearError()
        onHide()
    }
    
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: '400px' }}>
                {loading && <Loading expandHeight />}
                
                {error && (
                    <Alert variant="danger" dismissible onClose={clearError}>
                        {error}
                    </Alert>
                )}
                
                {!loading && settings && (
                    <Row>
                        <Col xs={4}>
                            <Stack gap={0}>
                                {Object.entries(CATEGORY_NAMES).map(([key, label]) => (
                                    <MenuButton
                                        key={key}
                                        id={key}
                                        text={label}
                                        checked={selectedCategory === key}
                                        onClicked={setSelectedCategory}
                                    />
                                ))}
                            </Stack>
                        </Col>
                        <Col>
                            {selectedCategory === CATEGORY_DIAGNOSTICS ? (
                                <DiagnosticsSection 
                                    hostUrl={settings.settings[CATEGORY_MOBILE_BANKING]?.data?.host_url}
                                    healthCheckPath={settings.settings[CATEGORY_MOBILE_BANKING]?.data?.health_check_path}
                                />
                            ) : (
                                <SettingsSection 
                                    section={selectedCategory}
                                    data={settings.settings[selectedCategory]}
                                />
                            )}
                        </Col>
                    </Row>
                )}
            </Modal.Body>
            {/* <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer> */}
        </Modal>
    )
}

export default CompanySettings